import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from './services/message.service';
import { CommonService } from './services/common/common.service';

@Injectable()
export class ApiInterceptorInterceptor implements HttpInterceptor {
  private pendingRequests = 0;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private _commonService: CommonService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // return next.handle(request);
    const token: any =
      localStorage.getItem('authToken') ??
      this._commonService.accessTokenForEmail;
    let newRequest;

    if (
      token &&
      !request.url.includes('/Login/api/userlogin') &&
      !request.url.includes('/Login/getUserAccessDetails') &&
      !request.url.includes('GetAngularAppVersions') &&
      !request.url.includes('version.json') &&
      !request.url.includes('https://zkynaikgmznxoylronqd.supabase.co')
    )
      newRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache, no-store',
          Pragma: 'no-cache',
        },
      });
    else newRequest = request;
    if (!request.url.includes('version.json')) this.showLoader();
    // else this.pendingRequests++;

    return next.handle(newRequest).pipe(
      tap((event: HttpEvent<any>) => {
        // Handle successful responses here
        if (event instanceof HttpResponse) {
          if (event.status === 207)
            this.messageService.infoToast(event?.body?.errorMessage);
          else if (event.status === 299)
            this.messageService.warningToast(event?.body?.errorMessage);
          // this.hideLoader(request?.url)
          if (
            !request.url.includes('/Login/api/userlogin') &&
            !request.url.includes('/Login/getUserAccessDetails') &&
            !request.url.includes('version.json')
          )
            this.hideLoader(request?.url);
          else if (!request.url.includes('version.json'))
            this.pendingRequests--;
          return;
        }
      }),

      catchError((error: HttpErrorResponse) => {
        if (!navigator.onLine) {
          // If there's no internet, throw an error
          this.messageService.errorToast('No Internet Connection');
          this.hideLoader(request?.url);
          // return throwError({ status: 0, message: 'No Internet Connection' });
        }
        // this.spinner.hide();
        else if (error instanceof HttpErrorResponse) {
          const statusCode = error.status;
          if (error.error instanceof Blob) {
            // If the error response is a Blob, attempt to parse it as JSON
            return new Observable<HttpEvent<any>>(observer => {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const errorJson = JSON.parse(reader.result as string);
                  this.messageService.errorToast(
                    errorJson.errorMessage || 'An unexpected error occurred.'
                  );
                } catch {
                  this.messageService.errorToast(
                    'An unexpected error occurred.'
                  );
                }
                observer.error(error);
                observer.complete();
                this.hideLoader(request?.url);
              };
              reader.readAsText(error.error);
            });
          }

          switch (statusCode) {
            case 401:
              this.messageService.errorToast('Your session has been expired.');
              this.hideLoader(request?.url);
              localStorage.clear();
              this.router.navigate(['/login']);
              break;

            case 403:
              if (
                !request.url.includes(
                  'https://zkynaikgmznxoylronqd.supabase.co'
                )
              )
                this.messageService.errorToast(error.error);
              this.hideLoader(request?.url);
              break;

            default:
              if (
                !request.url.includes(
                  'https://zkynaikgmznxoylronqd.supabase.co'
                )
              )
                this.messageService.errorToast(
                  error?.error?.errorMessage ||
                    error?.error?.error ||
                    'An unexpected error occurred.'
                );
              this.hideLoader(request?.url);
              break;
          }
        } else this.hideLoader(request?.url);
        return throwError(error);
      })
    );
  }

  private showLoader(): void {
    if (this.pendingRequests === 0) {
      this.spinner.show();
    }
    this.pendingRequests++;
  }

  private hideLoader(url: string): void {
    const endpoints = [
      '/GHG/GetGHGItemsByDCFGroupId',
      '/DropdownType/GetDropdownType?',
      '/GHG/GetInventory',
      '/DropdownType/GetDropdownitem?',
      '/GHG/GetGHGItemsByDCFGroupIdScope3',
    ];

    const shouldDelay = endpoints.some(endpoint => url.includes(endpoint));

    const decrementAndHideLoader = () => {
      if (this.pendingRequests > 0) {
        this.pendingRequests--;
      }

      if (this.pendingRequests <= 0) {
        this.spinner.hide();
        this.pendingRequests = 0;
      }
    };

    if (shouldDelay) {
      setTimeout(decrementAndHideLoader, 2000);
    } else {
      decrementAndHideLoader();
    }
  }
}
